import loadJS from '../../utils/load-js.js';

async function inititateFacebook (ID) {
    loadJS('https://connect.facebook.net/en_US/sdk.js').then(() => {
        if (!window.FB) {
            return;
        }

        window.FB.init({
            appId: ID,
            version: 'v3.3',
            status: true,
            xfbml: true
        });
    });
}

let isPageActive = true;

window.onfocus = function () {
    isPageActive = true;
};

window.onblur = function () {
    isPageActive = false;
};

function fallbackCopyTextToClipboard (text) {
    var textArea = document.createElement('textarea');
    textArea.className = 'u-hidden';
    textArea.value = text;
    document.querySelector('.c-share').appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
        var successful = document.execCommand('copy');
        var msg = successful ? 'successful' : 'unsuccessful';
        console.log('Fallback: Copying text command was ' + msg);
    } catch (err) {
        console.error('Fallback: Oops, unable to copy', err);
    }

    document.body.removeChild(textArea);
}

function showCopyTooltip () {
    const tooltip = document.querySelector('#copy-tooltip');

    if (tooltip) {
        tooltip.style.opacity = 1;

        setTimeout(() => {
            tooltip.style.opacity = 0;
        }, 3000);
    }
}

function copyTextToClipboard (text) {
    if (!navigator.clipboard) {
        fallbackCopyTextToClipboard(text);
        showCopyTooltip();
        return;
    }
    navigator.clipboard.writeText(text).then(function () {
        showCopyTooltip();
    }, function (err) {
        console.error('Async: Could not copy text: ', err);
    });
}

const inititateJobShare = () => {
    if (document.querySelector('.js-copy-to-clipboard')) {
        document.querySelector('.js-copy-to-clipboard').addEventListener('click', (e) => {
            e.preventDefault();
            copyTextToClipboard(window.location.origin + window.location.pathname + '?utm_source=copy_share_button_job_page ');
        });
    }

    const messenger = document.querySelector('.js-share-messenger');

    if (messenger) {
        messenger.addEventListener('click', (e) => {
            e.preventDefault();

            const target = e.currentTarget;

            window.location.href = 'fb-messenger://share/?link=' + encodeURIComponent(window.location.origin + window.location.pathname + '?utm_source=messenger_share_button_job_page&app_id=' + target.dataset.id);

            setTimeout(() => {
                if (document.hidden || !isPageActive) {
                    return;
                }

                window.location.href = target.href;
            }, 100);
        });
    }

    const whatsapp = document.querySelector('.js-share-whatsapp');

    if (whatsapp) {
        whatsapp.addEventListener('click', (e) => {
            e.preventDefault();

            const target = e.currentTarget;

            window.location.href = 'whatsapp://send?text=' + target.dataset.text;

            setTimeout(() => {
                if (document.hidden || !isPageActive) {
                    return;
                }

                window.open(target.href, '_blank');
            }, 100);
        });
    }

    const facebook = document.querySelector('.js-biuro-facebook');

    if (facebook) {
        setTimeout(() => {
            inititateFacebook(facebook.dataset.id);
        }, 1500);
    }
};

export default inititateJobShare;
